import { Box, Typography, Modal, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { SANS_FONT } from '../../../../theme'

export const WalletContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '16px',
  width: '100%',
  maxWidth: '562px',
  margin: '0 auto',
  paddingTop: '1.5rem',
  [theme.breakpoints.down('sm')]: {
    padding: '1rem 1rem 1.5rem',
    maxWidth: '100%',
  },
}))

export const VisaCardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: '32px 24px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '24px',
  alignSelf: 'stretch',
  borderRadius: '16px',
  border: '1.5px solid #EAECF0',
  background: `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, #1D2939 100%)`,
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    padding: '24px 20px',
    gap: '20px',
    borderRadius: '12px',
  },
}))

export const CardHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch',
})

export const VisaLogo = styled(Typography)(({ theme }) => ({
  color: '#FFF',
  fontFamily: SANS_FONT,
  fontSize: '28px',
  fontStyle: 'italic',
  fontWeight: 700,
  lineHeight: '36px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '24px',
    lineHeight: '32px',
  },
}))

export const CardNumber = styled(Typography)(({ theme }) => ({
  color: 'rgba(255, 255, 255, 0.9)',
  fontFamily: SANS_FONT,
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  letterSpacing: '1.5px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '1px',
  },
}))

export const BalanceOnCard = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  alignSelf: 'stretch',
  paddingTop: '8px',
  borderTop: '1px solid rgba(255, 255, 255, 0.2)',
})

export const BalanceLabel = styled(Typography)({
  color: 'rgba(255, 255, 255, 0.7)',
  fontFamily: SANS_FONT,
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
})

export const BalanceAmount = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontFamily: SANS_FONT,
  fontSize: '28px',
  fontWeight: 700,
  lineHeight: '36px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '24px',
    lineHeight: '32px',
  },
}))

export const BalanceSubtext = styled(Typography)({
  color: 'rgba(255, 255, 255, 0.7)',
  fontFamily: SANS_FONT,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
})

export const PayButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: '12px 24px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  alignSelf: 'stretch',
  borderRadius: '10px',
  background: theme.palette.primary.main,
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  '&:hover': {
    background: theme.palette.primary.dark,
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 12px rgba(218, 78, 28, 0.3)',
  },
  '&:active': {
    transform: 'translateY(0)',
  },
}))

export const PayButtonText = styled(Typography)({
  color: '#FFF',
  fontFamily: SANS_FONT,
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '24px',
})

export const ModalBalanceLabel = styled(Typography)({
  color: '#667085',
  fontFamily: SANS_FONT,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
})

export const ModalBalanceAmount = styled(Typography)({
  color: '#1D2939',
  fontFamily: SANS_FONT,
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '32px',
})

export const ModalBalanceSubtext = styled(Typography)({
  color: '#667085',
  fontFamily: SANS_FONT,
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
})

export const PaymentModal = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const ModalContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  maxWidth: '500px',
  background: '#FFF',
  borderRadius: '16px',
  padding: '32px',
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
  margin: '16px',
  [theme.breakpoints.down('sm')]: {
    padding: '24px 16px',
    margin: '8px',
    borderRadius: '12px',
    gap: '20px',
  },
}))

export const CloseButton = styled(IconButton)({
  position: 'absolute',
  top: '16px',
  right: '16px',
  color: '#667085',
})

export const ModalTitle = styled(Typography)(({ theme }) => ({
  color: '#1D2939',
  fontFamily: SANS_FONT,
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '32px',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '20px',
    lineHeight: '28px',
  },
}))

export const ModalInstructions = styled(Typography)(({ theme }) => ({
  color: '#667085',
  fontFamily: SANS_FONT,
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '20px',
  },
}))

export const QRWrapper = styled(Box)({
  padding: '24px',
  background: '#FFF',
  borderRadius: '12px',
  border: '2px solid #EAECF0',
})